import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { passworlessSignUp, passworlessUpdate, revokeSession } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const passworlessSignUpService = createAsyncThunk(
    'fetchPreAuthFAF', passworlessSignUp
)

const initialState = {
    loader: false
}

const passwordlessSignUpSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetPasswordlessSignUp: (state) => {
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(passworlessSignUpService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(passworlessSignUpService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(passworlessSignUpService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetPasswordlessSignUp } = passwordlessSignUpSlice.actions

export default passwordlessSignUpSlice.reducer

